import React, { useState, useEffect } from 'react';
import Modal from './Modal';

function DateInputModal({ 
  isOpen, 
  onClose, 
  onSubmit,
  title = "Enter to complete", 
  labels = ["Date (DD/MM/YYYY)"],
  etdetaDate,
  date
}) {
  // Initialize state as an object with keys from labels array
  const [userInputs, setUserInputs] = useState({});
  
  // Initialize inputs when modal opens or labels change
  useEffect(() => {
    if (isOpen && labels.length > 0) {
      const initialInputs = {};
      labels.forEach(label => {
        initialInputs[label] = userInputs[label] || '';
      });
      setUserInputs(initialInputs);
    }
  }, [isOpen]);
  
  // Reset fields when modal closes
  useEffect(() => {
    if (!isOpen) {
      setUserInputs({});
    }
  }, [isOpen]);
  
  // Function to handle date selection for a specific field
  const handleDateChange = (label, value) => {
    setUserInputs(prev => ({
      ...prev,
      [label]: value
    }));
  };
  
  // Function to handle form submission
  const handleSubmit = () => {
    const result = {};
  
    labels.forEach(label => {
      const input = userInputs[label]?.trim();
      const fallbackDate = date && !isNaN(new Date(date)) 
        ? new Date(date).toISOString().split("T")[0]
        : "";
  
      result[label] = input || fallbackDate;
    });
  
    // Check if all values are present (after fallback)
    const allInputsFilled = labels.every(label => result[label]);
  
    if (allInputsFilled) {
      onSubmit(result);
      setUserInputs({});
    }
  };
  
  // Check if submit button should be disabled (if any field is empty)
  const isSubmitDisabled = labels.some(label => !userInputs[label]?.trim()) && date === null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h4 className="mb-3">{title}</h4>
        
        {/* Date Pickers */}
        {labels.map((label, index) => (
          <div className="mb-3" key={index}>
            {['Final SOB Confirmation', 'Final ATA Confirmation'].includes(label) &&
              <aside style={{
                background: '#fff8e1',
                borderLeft: '4px solid #fbc02d',
                padding: '12px 16px',
                margin: '12px 0',
                borderRadius: '4px',
                color: '#888'
              }}>
                <i><strong>ETD/ETA Date:</strong> {etdetaDate}</i>
              </aside>
            }
            <label htmlFor={`datePicker-${index}`} className="form-label">{label} Date:</label>
            <input
              type="date"
              className="form-control"
              id={`datePicker-${index}`}
              value={
                userInputs[label] ||
                (date && !isNaN(new Date(date)) ? new Date(date).toISOString().split("T")[0] : "")
              }
              onChange={(e) => handleDateChange(label, e.target.value)}
            />
          </div>
        ))}
        
        <div className="d-flex justify-content-end">
          <button 
            className="btn btn-secondary me-2" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DateInputModal;